export default __webpack_public_path__ + "static/gridSize-562e39b0a0c424adb58d8225adb41876.gif";